// ========================================
// Central Configuration
// ========================================

const isDev = process.env.NODE_ENV === 'development';

const config = {
  // App
  appName: 'Roleplay Messages',
  appVersion: '1.0.0',
  baseUrl: isDev
    ? 'http://localhost:3000'
    : 'https://roleplaymessages.schoko-keks.de',
  isDev,

  // API Proxy (server-side, no API keys in frontend)
  apiUrl: isDev
    ? 'http://localhost:3000/api.php'
    : 'https://roleplaymessages.schoko-keks.de/api.php',

  // Import/Export Format
  format: {
    version: 1,
    addonName: 'RoleplayMessages',
  },

  // Defaults
  defaults: {
    textCount: 10,
    maxTextCount: 30,
    textLanguage: 'en',
    uiLanguage: 'en',
  },
};

export default config;
